import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes so later utilities win over earlier conflicting ones.
 * `clsx` handles conditionals; `twMerge` resolves e.g. `px-2 px-4` to `px-4`,
 * which plain string concatenation cannot.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
